import dates from 'dayjs'

export default {
  recent: {
    label: 'Recent',
    tooltip: 'Shipments registered within the last 30 days',
    filters () {
      const limit = dates().subtract(30, 'day').unix()
      return {
        preset: 'recent',
        search: {},
        facets: {},
        timestamps: {
          shipped_at: [limit, null]
        }
      }
    }
  }
}
